import { render, staticRenderFns } from "./SettingsTimeFrameInput.vue?vue&type=template&id=dee36a0a&"
import script from "./SettingsTimeFrameInput.vue?vue&type=script&lang=js&"
export * from "./SettingsTimeFrameInput.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTimeFrameInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports